import '/modules/edid/css/ui/edidRecordContainer.css';
import '/modules/edid/css/ui/edidRecordContainer.responsive.css';
import '/modules/edid/css/ui/edidRecordContainer.mobile.css';
import 'ol/ol.css';
import {AbstractContainer} from "../../common/timeseries/AbstractContainer";
import {formatDate} from "../../common/time/TimeCalculator";
import {EDIDSeverityEnum} from "../enum/EDIDSeverity";
import {EDIDSystemEnum} from "../enum/EDIDSystem";
import {hyperlinkURLs} from "../../common/util";
import Map from "ol/Map";
import TileLayer from "ol/layer/Tile";
import {OSM} from "ol/source";
import {Feature, View} from "ol";
import {MERCATOR_CODE, WGS84_CODE} from "../../common/config/config";
import {GeoJSON} from "ol/format";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {Fill, Stroke, Style} from "ol/style";
import {SimpleCoordinatesUIElement} from "../../common/ui/SimpleCoordinatesUIElement";
import {Projection} from "../../common/config/MainConfig";


class EdidRecordContainer extends AbstractContainer{
    getClassName(){
        return "EdidRecordContainer";
    }

    /**
     *
     * @param id {string} An HTML id for this selector container
     * @param record {Object} The drought impact record to show
     * @param closeFunc {function} A function that closes this record container
     */
    constructor(id, record, closeFunc) {
        super(id);
        this.expanded = true;
        this.record = record;
        this.closeFunc = closeFunc;
    }

    getContainerElement() {

        const content = $(
            '<div class="drought-impact-record container expanded">' +
            '   <header class="header">' +
            '       <div class="title">' +
            '           <h2>' + tumbo.translator.translate("edid.search.record.title",[this.record.id+'']) + '</h2>' +
            '       </div>' +
            '       <div class="buttons-container"></div>' +
            '   </header>' +
            '   <section class="body">' +
            '       <div class="column data">' +
            '       </div>' +
            '       <div class="column location">' +
            '       </div>' +
            '   </section>' +
            '</div>'
        );

        $('.buttons-container',content).append(
            $('<button>').attr('type','button').addClass('closer')
                .attr('title',tumbo.translator.translate('edid.search.record.close'))
                .click(this.closeFunc));

        const dataColumn = $('.body .data',content);
        ['sector','severity','time','description','reference','sources']
            .map(prop=>{
                const container = $('<div>').addClass('field').append($('<label>').html(tumbo.translator.translate('edid.search.record.'+prop)));
                let value = $('<div class="value">--</div>');
                switch (prop){
                    case 'sector':
                        value.html(EDIDSystemEnum.getForCode(this.record.system).getLocalizedName());
                        break;
                    case 'severity':
                        const sev = EDIDSeverityEnum.getForCode(this.record.severity);
                        value.html('<span class="color" style="background-color: '+sev.getColour()+'"></span>'+sev.getLocalizedName());
                        break;
                    case 'time':value.html(tumbo.translator.translate('edid.search.record.timeStr',[formatDate(this.record.start),formatDate(this.record.end_)])); break;
                    default: value.html(hyperlinkURLs(this.record[prop]));break;
                }
                return container.append(value);
            }).forEach(e=>dataColumn.append(e));
        dataColumn.append(
            $('<div>')
                .addClass('context')
                .html(tumbo.translator.translate(this.record.create_ts===this.record.last_update ? 'edid.search.record.createdStr':'edid.search.record.updatedStr',[formatDate(this.record.create_ts),formatDate(this.record.last_update)]))
        );

        const mapContainer = $('<div>').addClass('map');
        const locationColumn = $('.body .location',content)
            .append($('<div>').addClass('map-container field').append($('<label>').html(tumbo.translator.translate('edid.search.record.location'))).append(mapContainer));
        this._initMap(mapContainer);
        ['country','nuts1','nuts2','nuts3']
            .filter(prop=>!!this.record[prop+'_names'])
            .map(prop=> {

                let regionsStr = this.record[prop + '_names'];
                const regions = regionsStr.split(',');
                if(regions.length>=20){
                    regionsStr = regions.slice(0,14).join(', ')+'... <a style="cursor: pointer" class="show-all">['+tumbo.translator.translate('edid.search.record.showAllRegions')+']</a>';
                }
                const field = $('<div>').addClass('field').append($('<label>').html(tumbo.translator.translate('edid.search.record.' + prop)))
                    .append($('<div>').addClass('value').html(regionsStr));

                $('a.show-all',field).click(()=>$('.value',field).html(regions.join(', ')));

                return field;
            }).forEach(e=>locationColumn.append(e));

        return content;
    }

    _initMap(target){
        target.empty()
            .append(
                '<figure>' +
                '   <div role="figure" aria-labelledby="figcaption_recordlocation"></div>' +
                '   <figcaption id="figcaption_recordlocation">Location of drought impact record '+this.record.id+'</figcaption>' +
                '</figure>'
            );
        const geom = new GeoJSON().readGeometry(this.record.geom).transform(WGS84_CODE,MERCATOR_CODE);
        const map = new Map({
            layers: [new TileLayer({source: new OSM({url: 'https://gisco-services.ec.europa.eu/maps/tiles/OSMCartoComposite/EPSG3857/{z}/{x}/{y}.png'})})],
            target: $('div', target)[0],
            view: new View({
                minZoom: 1,
                multiWorld: true,
                projection: MERCATOR_CODE,
            })
        });
        target = $($('div', target)[0]);

        const coordinates = new SimpleCoordinatesUIElement(Projection.MERCATOR_PROJECTION, target, $('.ol-overlaycontainer-stopevent', target));
        coordinates.getOLControls().forEach(c => map.addControl(c));
        target.append(coordinates.getUIElement());
        map.addLayer(new VectorLayer({
            source: new VectorSource({
                features:[new Feature(geom)]
            }),
            style: [
                new Style({
                    stroke: new Stroke({
                        color:'white',
                        width: 4
                    })

                }),
                new Style({
                    fill: new Fill({color: 'rgba(231, 165, 37, 0.1)'}),
                    stroke: new Stroke({
                        color:'#286e9f',
                        width: 1
                    })
                })
            ]
        }))
        map.getView().fit(geom.getExtent());
    }

    isCollapsible() {
        return false;
    }
}

export {EdidRecordContainer}